import { render, staticRenderFns } from "./BannerSoporte.vue?vue&type=template&id=f73f061a&scoped=true"
import script from "./BannerSoporte.vue?vue&type=script&lang=js"
export * from "./BannerSoporte.vue?vue&type=script&lang=js"
import style0 from "./BannerSoporte.vue?vue&type=style&index=0&id=f73f061a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73f061a",
  null
  
)

export default component.exports